var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.geoipLocation
      ? _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.gettext(
                  "Based on the information delivered by your web browser you appear to be located in:"
                )
              ) +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group flex" }, [
      _c("div", { staticClass: "input-group input-group-select" }, [
        _c(
          "div",
          {
            staticClass: "select-wrapper",
            class: {
              error:
                _vm.$v.province.$error ||
                (!_vm.$v.province.$dirty && _vm.$v.city.$dirty),
              valid: _vm.$v.province.$dirty && !_vm.$v.province.$invalid
            }
          },
          [
            _c(
              "label",
              {
                staticClass: "visually-hidden",
                attrs: { for: "signup-province" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.pgettext(
                      "Select province label",
                      "Select province or territory"
                    )
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.province,
                    expression: "province"
                  }
                ],
                attrs: { name: "signup-province", id: "signup-province" },
                on: {
                  input: _vm.$v.province.$touch,
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.province = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.pgettext("Select province", "Province or territory")
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.provinces, function(province) {
                  return _c(
                    "option",
                    {
                      key: province.abbreviation,
                      domProps: { value: province.abbreviation }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(province.name) +
                          "\n              "
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _vm.$v.province.$dirty &&
        (!_vm.$v.province.required && !_vm.$v.city.$error)
          ? _c("span", { staticClass: "form-error" }, [
              _vm._v(
                _vm._s(_vm.gettext("Please select a province or territory."))
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.$v.province.$dirty && _vm.$v.city.$dirty
          ? _c("span", { staticClass: "form-error" }, [
              _vm._v(
                _vm._s(
                  _vm.gettext("Please select a province or territory first.")
                )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$v.province.$dirty &&
        _vm.$v.city.$dirty &&
        (!_vm.$v.province.required && !_vm.$v.city.required)
          ? _c("span", { staticClass: "form-error" }, [
              _vm._v(
                _vm._s(
                  _vm.gettext(
                    "Please select a province or territory, and city."
                  )
                )
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group input-group-select right-margin-0" },
        [
          _c(
            "div",
            {
              staticClass: "select-wrapper",
              class: {
                error: _vm.$v.city.$error,
                valid: _vm.$v.city.$dirty && !_vm.$v.city.$invalid
              }
            },
            [
              _c(
                "label",
                {
                  staticClass: "visually-hidden",
                  attrs: { for: "signup-city" }
                },
                [
                  _vm._v(
                    _vm._s(_vm.pgettext("Select city label", "Select city"))
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.city,
                      expression: "city"
                    }
                  ],
                  attrs: { name: "signup-city", id: "signup-city" },
                  on: {
                    input: _vm.$v.city.$touch,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.city = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.pgettext("Select city", "City")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.cities, function(city) {
                    return _c(
                      "option",
                      { key: city, domProps: { value: city } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(city) +
                            "\n              "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.$v.province.$dirty &&
          _vm.$v.city.$dirty &&
          (!_vm.$v.city.required && !_vm.$v.province.$error)
            ? _c("span", { staticClass: "form-error" }, [
                _vm._v(_vm._s(_vm.gettext("Please select a city.")))
              ])
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _vm.geoipLocation
      ? _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.gettext(
                  "If the above information is not accurate, please click on the dropdown and select the correct response."
                )
              ) +
              "\n    "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-eebe973e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eebe973e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/CityPicker.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-eebe973e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/CityPicker.vue
// module chunks = 0